/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ClientsConfiguration } from './clientsConfiguration';


export interface CompanyBaseDataWithClients { 
    company: string;
    name: string;
    key: string;
    clients?: Array<ClientsConfiguration>;
}

